export default __webpack_public_path__ + "static/media/mobiles.e20f884a.PNG";